import React from 'react';
import {Container} from '@mui/material';

export interface FooterProps {
  children: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal;
  sx?: object;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

function Footer(props: FooterProps) {
  const {children, sx, maxWidth} = props;

  return (
    <Container maxWidth={maxWidth} sx={sx}>
      {children}
    </Container>
  );
}

export default Footer;
